export const NEW_TABID_PREFIX = 'new-';
export const NEW_TABNAME_PREFIX = 'Comparison ';
export const NEW_SHARING_DASHBOARD_NAME = 'Shared Dashboard ';
export const TIMELINE_TAB_NAME = 'Timeline';
export const NOC_SHARING_DASHBOARD_NAME = 'Real-Time Sharing ';
export const OVB_SHARING_DASHBOARD_NAME = 'Overview Sharing ';
export const ML_SHARING_DASHBOARD_NAME = 'MetricLens Sharing ';
export const VM_SHARING_DASHBOARD_NAME = 'Viewer Module Sharing ';
